import { useEffect, useRef } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { Spinner } from '@ui/components/loaders'
import { useSetupNodesEdges } from '@ui/lib/hooks/useSetupNodesEdges'
import { PipelineWorkflow } from '@ui/pages/pipelinesWorkflow/PipelineWorkflow'
import { FeatureFlagName, useFeatureFlag } from '@ui/providers/FeatureFlagProvider'
import { usePipelinesStore } from '@ui/stores'

import { PipelineWorkflowV2 } from './PipelineWorkflowV2'

export const NewPipeline = () => {
  const workflowUpdateEnabled = useFeatureFlag(FeatureFlagName.WorkflowUpdate)
  const loading = useRef(true)

  const { isSettingUpPipeline, pipeline } = useSetupNodesEdges({ isNew: true, withSteps: workflowUpdateEnabled })

  const { selectPipeline } = usePipelinesStore(
    useShallow((state) => ({
      selectPipeline: state.selectPipeline,
    }))
  )

  // Select the pipeline
  useEffect(() => {
    if (pipeline) {
      selectPipeline(pipeline)
      loading.current = false
    }

    return () => {
      selectPipeline(null)
    }
  }, [selectPipeline, pipeline])

  if (isSettingUpPipeline) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner />
      </div>
    )
  }

  return workflowUpdateEnabled ? <PipelineWorkflowV2 /> : <PipelineWorkflow />
}
